<template>
  <div class="side-nav-outer-toolbar">
    <header-toolbar
      class="layout-header"
      :menu-toggle-enabled="true"
      :toggle-menu-func="toggleMenu"
      :title="title"
    />
    <dx-drawer
      class="layout-body"
      position="before"
      template="menuTemplate"
      v-model:opened="menuOpened"
      :opened-state-mode="drawerOptions.menuMode"
      :reveal-mode="drawerOptions.menuRevealMode"
      :min-size="drawerOptions.minMenuSize"
      :max-size="drawerOptions.maxMenuSize"
      :shading="drawerOptions.shaderEnabled"
      :close-on-outside-click="drawerOptions.closeOnOutsideClick"
    >
      <dx-scroll-view ref="scrollViewRef" class="with-footer">
        <slot />
        <slot name="footer" />
      </dx-scroll-view>
      <template #menuTemplate>
        <side-nav-menu
          :compact-mode="!menuOpened"
          @click="handleSideBarClick"
        />
      </template>
    </dx-drawer>
  </div>
</template>

<script>
import DxDrawer from "devextreme-vue/drawer";
import DxScrollView from "devextreme-vue/scroll-view";

import menuItems from "../app-navigation";
import HeaderToolbar from "../components/header-toolbar";
import SideNavMenu from "../components/side-nav-menu";
import { computed, ref, watch} from 'vue';
import { useRoute } from 'vue-router';

export default {
  props: {
    title: String,
    isXSmall: Boolean,
    isLarge: Boolean
  },
  setup(props) {
    const route = useRoute();

    const scrollViewRef = ref(null);
    const menuOpened = ref(props.isLarge);
    const menuTemporaryOpened = ref(false);

    function toggleMenu(e) {
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
      if (menuOpened.value) {
        menuTemporaryOpened.value = false;
      }
      menuOpened.value = !menuOpened.value;
    }

    function handleSideBarClick() {
      if (menuOpened.value === false) {
        menuTemporaryOpened.value = true;
      }
      menuOpened.value = true;
    }

    const drawerOptions = computed(() => {
      const shaderEnabled = !props.isLarge;

      return {
        menuMode: props.isLarge ? "shrink" : "overlap",
        menuRevealMode: props.isXSmall ? "slide" : "expand",
        minMenuSize: props.isXSmall ? 0 : 60,
        maxMenuSize: props.isXSmall ? 250 : undefined,
        closeOnOutsideClick: shaderEnabled,
        shaderEnabled
      };
    });

    watch(
      () => props.isLarge,
      () => {
        if (!menuTemporaryOpened.value) {
          menuOpened.value = props.isLarge;
        }
    });

    watch(
      () => route.path,
      () => {
        if (menuTemporaryOpened.value || !props.isLarge) {
          menuOpened.value = false;
          menuTemporaryOpened.value = false;
        }
      scrollViewRef.value.instance.scrollTo(0);
      }
    );

    return {
      menuOpened,
      menuItems,
      toggleMenu,
      handleSideBarClick,
      drawerOptions,
      scrollViewRef
    };
  },
  components: {
    DxDrawer,
    DxScrollView,
    HeaderToolbar,
    SideNavMenu
  }
};
</script>

<style lang="scss">
.side-nav-outer-toolbar {
  flex-direction: column;
  display: flex;
  height: 100%;
  width: 100%;
}

.layout-header {
  z-index: 1501;
}


li[aria-level="1"] {
     background-color: #232329 !important;
}

li[aria-level="2"] {
     background-color: #363640 !important;
}

li[aria-level="3"] {
     background-color: #484851 !important;
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-node[aria-level="2"] .dx-treeview-item-content {
  padding: 0 0 0 10px !important;
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-node[aria-level="1"] .dx-item.dx-treeview-item {
  font-size: 14px;
  padding: 16px 0 16px;
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-node[aria-level="2"] .dx-item.dx-treeview-item {
  padding: 9px 0 9px 16px !important;
  font-size: 13px;
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-node[aria-level="2"] i {  
  font-size: 4px;
  width: 40px !important;
}

.dx-swatch-additional .dx-treeview-item .dx-treeview-item-content > .dx-icon {
    font-size: 24px;
    color: rgba(255, 255, 255, .5);  
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-node[aria-level="2"] .dx-treeview-item-content {
    padding: 0 20px 0 10px;
}

li[aria-level="1"] .dx-treeview-item .dx-treeview-item-content > .dx-treeview-toggle-item-visibility {
  display: none;
}

li span {
  font-weight: 300;
}

li[aria-level="1"] > .dx-item.dx-treeview-item .dx-item-content.dx-treeview-item-content span {
  font-size: 14px;
}

li[aria-level="2"] .dx-treeview-item .dx-treeview-item-content > .dx-icon {
  font-size: 9px;
}

li[aria-level="3"] .dx-treeview-item .dx-treeview-item-content > .dx-icon {
  font-size: 9px;
}

.side-navigation-menu .menu-container .dx-treeview .dx-treeview-item .dx-icon {
    width: 60px !important;
    margin: 0 !important;
}

.dx-icon.dx-icon-menu {
    font-size: 24px;    
}

.dx-icon {
  vertical-align: middle !important;
}

.menu-button {
    width: 46px;
}

.dx-item-content {
  display: block;
  width: 100%;
  white-space: normal;
}

.dx-treeview-item .dx-treeview-item-content span {
  vertical-align: middle;
  white-space: wrap;  
  display: inline-block !important;
  width: 145px;
  font-weight: 300;
}

.dx-checkbox.dx-state-readonly .dx-checkbox-icon {
  color: #0a8872;
  background-color: #ffffff;
}


</style>
